var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCowboys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Logo Icons / NFL / Cowboys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Logo-Icons-/-NFL-/-Cowboys",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DAL"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 70 0 70 70 0 70"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "68.46756 27.5366 43.03502 27.5366 34.93364 3.30932 26.83156 27.5366 1.39986 27.5366 22.23662 42.45416 14.23772 66.6953 34.93364 51.91172 55.6311 66.66688 47.62982 42.455 68.46742 27.53674"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#002244",
    fillRule: "nonzero",
    points: "34.93378 6.19248 27.48214 28.441 4.21358 28.441 23.303 42.10626 15.9614 64.35408 34.93756 50.80194 53.90756 64.35408 46.56288 42.10626 65.653 28.441 42.38444 28.441 34.93364 6.19248"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "34.93378 12.32434 28.94164 30.34514 10.094 30.34514 25.55686 41.41438 19.61022 59.43434 34.97998 48.4582 50.2565 59.43434 44.30986 41.41508 59.77356 30.34514 40.92508 30.34514 34.93378 12.32434"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#002244",
    fillRule: "nonzero",
    points: "34.93378 17.62418 30.22418 31.8605 15.3363 31.8605 27.5506 40.60532 22.85178 54.84164 34.99524 46.1699 47.0148 54.84164 42.31514 40.60602 54.53028 31.86036 39.6424 31.86036 34.9335 17.62404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowboys);
export default __webpack_public_path__ + "static/media/Cowboys.53ca80f26e5a8e82c1bd7d90105b070d.svg";
export { ForwardRef as ReactComponent };